import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-site-name',
  imports: [],
  templateUrl: './site-name.html',
  styleUrl: './site-name.scss',
})
export class SiteName {
  get appname(): string {
    return environment.appname;
  }
}
